<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Vara'"
      :no-label="noLabel"
      :helper="helper"
      :helper-position="helperPosition || 'lb'"
      :error="error"
      :label-width="labelWidth"
      :style="fieldStyle"
  >
    <erp-select
        @input="__set"
        :loading="loading"
        :multiple="multiple"
        :placeholder="!selectNull ? placeholder || 'Qualquer' : ''"
        :options="status"
        v-model="model"
        propoverClass="select-status-def1"
        :disable="disable || !list"
        :style="inputStyle"
        :simple-border="simpleBorder"
        :size="size || '1'"
    >
    </erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../../mixins/SelectMixin'
import {list} from '@/domain/processos/services/vara'

export default {
  name: 'VaraSelect',
  mixins: [SelectMixin],
  props: {
    selectNull: {
      type: Boolean,
      default: false
    },
    comarca: {
      required: true,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      list: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.load()
    })
  },
  watch: {
    comarca (v) {
      this.$nextTick(() => {
        this.load()
      })
    }
  },
  computed: {
    status () {
      const s = []
      this.selectNull && s.push({
        label: this.placeholder || 'Qualquer',
        value: null
      })
      if (this.list && this.list.length) {
        this.list.map(status => {
          s.push({
            ...status,
            label: status.nome,
            value: status.id
          })
        })
      }
      return s
    }
  },
  components: {},
  methods: {
    load () {
      if (!this.comarca) return
      this.loading = true
      list(1000, 1, '&comarca=' + this.comarca)
          .then(({data}) => {
            this.list = data.result || data
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.alertApiError(error)
          })
    },
    __updateInternal () {
      this.$nextTick(() => {
        if (this.value !== 'undefined' && this.value !== null && this.model === null) {
          let _cp = JSON.stringify(this.value) // force to update datepicker with actual value
          this.model = ''
          setTimeout(() => {
            this.model = JSON.parse(_cp)
          }, 1)
        }
      })
    }
  }
}
</script>

